var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1765_15724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 -0.00390625C6.03546 0.00362627 2.44939 2.35159 0.857144 5.98236C-0.735106 9.61312 -0.0330989 13.8416 2.64695 16.7631C4.54089 18.816 7.20686 19.9837 10 19.9837C12.7932 19.9837 15.4591 18.816 17.3531 16.7631C20.0331 13.8416 20.7351 9.61312 19.1429 5.98236C17.5506 2.35159 13.9646 0.00362627 10 -0.00390625ZM10 18.0036C7.92762 18.0004 5.93724 17.1935 4.4477 15.7526C5.37262 13.501 7.56581 12.0309 10 12.0309C12.4342 12.0309 14.6274 13.501 15.5523 15.7526C14.0628 17.1935 12.0724 18.0004 10 18.0036ZM7.99918 7.99941C7.99918 6.89438 8.89498 5.99857 10 5.99857C11.105 5.99857 12.0008 6.89438 12.0008 7.99941C12.0008 9.10443 11.105 10.0002 10 10.0002C8.89498 10.0002 7.99918 9.10443 7.99918 7.99941ZM16.9129 14.0019C16.0191 12.4731 14.6433 11.2838 13.0013 10.6205C14.4201 9.01175 14.318 6.57037 12.7699 5.0856C11.2218 3.60083 8.77826 3.60083 7.23013 5.0856C5.68199 6.57037 5.57994 9.01175 6.99876 10.6205C5.35668 11.2838 3.98098 12.4731 3.08713 14.0019C2.37478 12.7885 1.9984 11.4073 1.99668 10.0003C1.99668 5.58016 5.57989 1.99695 10 1.99695C14.4201 1.99695 18.0033 5.58016 18.0033 10.0003C18.0016 11.4073 17.6252 12.7885 16.9129 14.0019Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1765_15724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.96bba08b0e25bfcb9ba21e58c0bed201.svg";
export { ForwardRef as ReactComponent };